module.exports = __webpack_public_path__ + "img/CS-Hybrid_Overview-Rear_3.fab1cc04.jpg";